import { Injectable } from '@angular/core';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { Http, Response } from '@angular/http';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SurveyService extends ParentService {

  constructor(private http: Http) {
    super();
  }

  /**
   * @description
   */
  public getQuestions() {
    return this.http.get(constant.URL_SURVEY_QUESTIONS, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description
   * @param data
   */
  public storeSurvey(data) {
    const bodyString = JSON.stringify(data);
    return this.http.post(constant.URL_SURVEY, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param tripid
   */

  public getSurvey(tripid) {
    return this.http.get(constant.URL_SURVEY_ANSWER + tripid, this.getHeader())
      .map(resp => resp.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/survey/survey.service.ts